import React, { useState, useEffect } from "react";
import {Link, NavLink, } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Actions from 'redux/actions';
import get from 'lodash.get';
import Logo from 'assets/images/logo.png';
import axios from 'axios';
import Dropdown from '../Dropdown';
import {useTranslation} from "react-i18next";
import LoadAll from 'schema/container/LoadAll';
import Bar from "assets/images/bar.svg";

const handleVision = (e, type=1) => {
  e.stopPropagation = true;
  e.keepOpen = true;
  const body = document.querySelector("body");

  if(type === 1){
    body.classList.remove("greyscale");
  }else{
    body.classList.add("greyscale");
  }
};

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [weather, setWeather] = useState({});
  const [sidebar, setSidebar] = useState(false);
  const { system: { language }} = useSelector(state => state);

  useEffect(() => {
    axios.get("https://api.openweathermap.org/data/2.5/weather?lat=41.311081&lon=69.240562&appid=7b2977ba27934154562b80af6088969e&units=metric")
      .then(({ data={} }) => {
        setWeather(data);
      })
      .catch(() => {
        console.log("Xatolik yuz berdi");
      })
  }, []);

  useEffect(() => {
    const html = document.querySelector("html");
    if(sidebar){
      html.classList.add("overflow");
    }else{
      html.classList.remove("overflow");
    }
  }, [sidebar]);

  const handleLanguage = lang => {
      dispatch(Actions.CHANGE_LANG.success(lang));
      setTimeout(() => {
        window.location.reload();
      }, 500);
  };

  return (
    <header>
      <div className={"header-top py-3"}>
        <div className="container">
          <div className={"d-flex align-items-center justify-content-between"}>
            <Link className={"main-logo d-flex align-items-center text-primary fs-18 fw-500 text-uppercase"} to="/">
              <img className={"me-2"} width={40} src={Logo} alt="O'zbekgidrogeologiya"/>
              O’zbekgidrogeologiya
            </Link>
            <div className={"d-none d-lg-inline-block"}>
              {
                Object.keys(weather).length
                ? <span>Toshkent
                    {" "}
                    {
                      parseInt(get(weather, 'main.feels_like', 0)) >= 0
                      ? "+"
                      : "-"
                    }
                    {Math.abs(parseInt(get(weather, 'main.feels_like', 0)))}
                    &#176;
                  </span>
                : null
              }
            </div>
            <div className={"d-flex align-items-center"}>
              <a className={"btn btn-sm border-primary focus-none text-primary d-none d-lg-inline-block"} href="mailto:ggpuz@mail.ru" rel={"noopener noreferrer"}>
                <i className={"fas fa-envelope me-2"}/>
                ggpuz@mail.ru
              </a>
              <span className={"text-custom-grey px-3 d-none d-lg-inline-block"}>|</span>
              <Dropdown
                align={"center"}
                menuButton={
                  <span className={"cursor-pointer text-custom-grey "}>
                    <i className={"fas fa-eye"}/>
                  </span>
                }
                render={({ MenuItem }) => {
                  return <>
                    <MenuItem
                      onClick={e => handleVision(e, 1)}
                    >{t("header.nav15")}</MenuItem>
                    <MenuItem
                      onClick={e => handleVision(e, 2)}
                    >{t("header.nav16")}</MenuItem>
                  </>
                }}
              />
              <span className={"text-custom-grey px-3"}>|</span>
              <span className={`${language === 'uz' ? 'text-custom-blue' : 'text-custom-grey' } me-1 cursor-pointer fs-18`} onClick={() => handleLanguage("uz")}>uz</span>
              <span className={`${language === 'ru' ? 'text-custom-blue' : 'text-custom-grey' } me-1 cursor-pointer fs-18`} onClick={() => handleLanguage("ru")}>ru</span>
              <span className={`${language === 'en' ? 'text-custom-blue' : 'text-custom-grey' } me-1 cursor-pointer fs-18`} onClick={() => handleLanguage("en")}>en</span>

              <span className={"cursor-pointer ms-3 d-lg-none"} onClick={() => setSidebar(!sidebar)}>
                <img width={24} src={Bar} alt="Sidebar icon"/>
              </span>

            </div>
          </div>
        </div>
      </div>
      <div className={`header-bottom bg-custom-blue text-white p-4 p-lg-0 ${sidebar ? "open" : ''}`}>
        <span className={"sidebar-close d-lg-none"} onClick={() => setSidebar(false)}>&times;</span>
        <div className="container-xl">
          <LoadAll
            name={"headerMenu"}
            url={"/menu/header-menu"}
            params={{
              extra: {
                lang: language
              }
            }}
            asData
          >
            {({ isFetched, data=[]}) => {
              return <>
                {
                  isFetched && data?.length
                  ? <ul className={"d-lg-flex align-items-center"}>
                        {
                          data.map((item, key) => {
                            if (get(item, 'children')?.length) {
                              return <li className={"header-nav-item me-sm-1 me-md-2 me-lg-2 me-xl-3 me-xxl-5"} key={key}>
                                <Dropdown
                                    menuButton={
                                      <span
                                          className={"nav-item-text d-flex align-items-center py-3 text-white cursor-pointer text-uppercase"}>
                                    {get(item, `name_${language}`)}
                                        <i className={"fal fa-angle-down ms-1 fs-18"}/>
                                  </span>
                                    }
                                    render={({MenuItem}) => {
                                      return <>
                                        {
                                          get(item, "children")?.map((child, key) => (
                                              <MenuItem key={key}>
                                                <Link onClick={() => sidebar && setSidebar(false)}
                                                      to={get(child, "url") ? get(child, "url") : '/'}>{get(child, `name_${language}`)}</Link>
                                              </MenuItem>
                                          ))
                                        }
                                      </>
                                    }}
                                />
                              </li>
                            } else {
                              return <li className={"header-nav-item me-sm-1 me-md-2 me-lg-2 me-xl-3 me-xxl-5"} key={key}>
                                <NavLink onClick={() => sidebar && setSidebar(false)}
                                         className={"nav-item-text d-block py-3 text-white text-uppercase"}
                                         to={get(item, "url") ? get(item, "url") : '/'}>{get(item, `name_${language}`, '')}</NavLink>
                              </li>
                            }
                          })
                        }
                      </ul>
                      : null
                }
                {
                  !isFetched
                      ? <div className={"py-4"}/>
                      : null
                }
              </>
            }}
          </LoadAll>
        </div>
      </div>
      <div className={`header-mask d-lg-none ${sidebar ? 'active' : ''}`} onClick={() => setSidebar(false)} />
    </header>
  );
};

export default Header;